module.exports = __webpack_public_path__ + "img/create.fefac10a.png";